export default class Hitbox{
    constructor({x, y, w, h}){
      this.set({x,y,w,h});
    }

    set({x, y, w, h}){
        this.x = x - w/2;
        this.y = y - h/2;
        this.w = w;
        this.h = h;
    }

    overlaps(other){
        if(this.x >= other.x + other.w || other.x >= this.x + this.w) return false;
        if(this.y >= other.y + other.h || other.y >= this.y + this.h) return false;
        return true;
    }
    
    debug(ctx){
        ctx.strokeStyle = "green"
        ctx.strokeRect(this.x, this.y, this.w, this.h);
    }
}